module.exports = __webpack_public_path__ + "img/grass-tile-0008.9674ed6e.jpg";